export default __webpack_public_path__ + "media/images/metal_detect/foxes_detect_2-c836c4be025114e84543766565a339e3.svg";